"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ModalCloseIcon = _interopRequireDefault(require("./ModalCloseIcon"));
var ModalHeader = function ModalHeader(_ref) {
  var closeFunc = _ref.closeFunc,
    heading = _ref.heading,
    headingStyle = _ref.headingStyle,
    closeIconLeftAligned = _ref.closeIconLeftAligned,
    icon = _ref.icon,
    elementLocator = _ref.elementLocator;
  return _react.default.createElement("div", {
    className: "modal-Header"
  }, _react.default.createElement(_ModalCloseIcon.default, {
    className: "close-modal",
    closeFunc: closeFunc,
    closeIconLeftAligned: closeIconLeftAligned,
    icon: icon,
    elementLocator: elementLocator + "-close-icon"
  }), heading && _react.default.createElement("div", (0, _extends2.default)({
    className: "modal_Heading"
  }, headingStyle), heading));
};
ModalHeader.defaultProps = {
  heading: '',
  icon: '',
  headingStyle: {},
  closeIconLeftAligned: false,
  closeFunc: function closeFunc() {
    /* default closeFunc handler */
  },
  elementLocator: 'modal'
};
var _default = ModalHeader;
exports.default = _default;
module.exports = exports["default"];